// All Icons should be exported from here, even if we are using a third party library so we can easily switch to a different library in the future.
// if there are any svg icons, put it in this folder then export it from here.

import {
  Cross2Icon,
  EyeNoneIcon,
  HeartFilledIcon,
  MagnifyingGlassIcon,
  CalendarIcon as RadixCalendarIcon,
  CheckIcon as RadixCheckIcon,
  ChevronDownIcon as RadixChevronDownIcon,
  ChevronLeftIcon as RadixChevronLeftIcon,
  ChevronRightIcon as RadixChevronRightIcon,
  ChevronUpIcon as RadixChevronUpIcon,
  CopyIcon as RadixCopyIcon,
  DashIcon as RadixDashIcon,
  DoubleArrowLeftIcon as RadixDoubleArrowLeftIcon,
  DoubleArrowRightIcon as RadixDoubleArrowRightIcon,
  EyeOpenIcon as RadixEyeOpenIcon,
  PersonIcon as RadixPersonIcon,
} from "@radix-ui/react-icons";
import {
  ArrowRightLeft,
  Award,
  BookOpen,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronUp,
  Clock,
  Download,
  Eye,
  File,
  FileText,
  Globe,
  Heart,
  Home,
  Image,
  Loader2,
  Maximize2,
  Moon,
  Share2,
  ShoppingCartIcon,
  Star,
  Sun,
  ThumbsUp,
  Trash,
  Trash2,
  Video,
  X,
  XCircle,
  Radio,
  Lock,
  MessageCircle,
} from "lucide-react";

// Icons exports
export const LoaderIcon = Loader2;
export const CheckCircleIcon = CheckCircle;
export const XCircleIcon = XCircle;
export const XIcon = X;
export const StarIcon = Star;
export const CheckIcon = Check;
export const Check2Icon = RadixCheckIcon;
export const ChevronDownIcon = ChevronDown;
export const ChevronDown2Icon = RadixChevronDownIcon;
export const ChevronUpIcon = ChevronUp;
export const ChevronUp2Icon = RadixChevronUpIcon;
export const ChevronLeftIcon = RadixChevronLeftIcon;
export const ChevronRightIcon = RadixChevronRightIcon;
export const TrashIcon = Trash;
export const Trash2Icon = Trash2;
export const FileIcon = File;
export const GlobeIcon = Globe;
export const MoonIcon = Moon;
export const SunIcon = Sun;
export const HomeIcon = Home;
export const HeartIcon = Heart;
export const HeartSolidIcon = HeartFilledIcon;
export const ThumbsUpIcon = ThumbsUp;
export const EyeClosedIcon = EyeNoneIcon;
export const EyeOpenIcon = RadixEyeOpenIcon;
export const CalendarIcon = RadixCalendarIcon;
export const SearchIcon = MagnifyingGlassIcon;
export const CloseIcon = Cross2Icon;
export const DoubleArrowLeftIcon = RadixDoubleArrowLeftIcon;
export const DoubleArrowRightIcon = RadixDoubleArrowRightIcon;
export const DashIcon = RadixDashIcon;
export const CopyIcon = RadixCopyIcon;
export const PersonIcon = RadixPersonIcon;
export const CartIcon = ShoppingCartIcon;
export const CompareIcon = ArrowRightLeft;
export const ShareIcon = Share2;
export const QuickViewIcon = Maximize2;

// Additional icons for lesson details
export const EyeIcon = Eye;
export const ClockIcon = Clock;
export const FileTextIcon = FileText;
export const ImageIcon = Image;
export const VideoIcon = Video;
export const AudioIcon = Radio;
export const DownloadIcon = Download;
export const AwardIcon = Award;
export const BookOpenIcon = BookOpen;
export const LockIcon = Lock;
export const MessageCircleIcon = MessageCircle;
